import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import MovieCard from "@/components/feature/MovieCard";

interface MovieSectionProps {
  title: string;
  subtitle: string;
  movies: Movie[];
  moreHref: string;
  rank?: boolean;
}

export default function MovieSection({
  title,
  subtitle,
  movies,
  moreHref,
  rank,
}: MovieSectionProps) {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
      <div className="mb-6 flex items-end justify-between">
        <div className="flex items-center gap-3">
          <span className="h-8 w-1.5 rounded-full bg-accent-500"></span>
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              {title}
            </h2>
            <p className="mt-0.5 text-sm text-foreground-600">{subtitle}</p>
          </div>
        </div>
        <Link
          to={moreHref}
          className="flex items-center gap-1 whitespace-nowrap text-sm text-accent-500 transition-colors hover:text-accent-400"
        >
          查看更多
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-4 xl:grid-cols-6">
        {movies.map((movie, i) => (
          <MovieCard key={movie.id} movie={movie} rank={rank ? i + 1 : undefined} />
        ))}
      </div>
    </section>
  );
}